module.exports = __webpack_public_path__ + "static/img/kv_air.12660ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/kv_air.png
// module id = Pu7/
// module chunks = 1